import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { View, TouchableOpacity } from 'react-native';
import styled, { useTheme } from 'styled-components/native';
import { Heading, Heading4, Button, BasicText as Text, BasicText } from '../Styles';
import { COLORS } from '../../WasteTheme';

const injectScopeToChildren = (children, props) => {
    return React.Children.map(children,  (child)=>{
        return React.cloneElement( child, props, children );
    });
}

const DayHeading = styled(View)`
    width: 14.28%;
    height: 15px;
    text-align: center;
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.5px;
`;

const Day = styled.TouchableOpacity`
    display: flex;
    width: 14.28%;
    border-width: 1px;
    border-color: #ccc;
    padding: 5px;
    border-collapse: collapse;
    min-height: 103px;
`;

const DayOfMonth = styled.View`
    position: relative;
    top: -5px;
    left: -5px;
    width: 100%;
    text-align: center;
`;

const DayOfMonthText = styled.Text`
    position: relative;
    color: #666;
    background-color: #f1f1f1;
    width: 20px;
`;

const CalendarHeading = styled(Heading)`
    text-align: center;
`;

const Controls = styled.View`
    flex-direction: row;
    justify-content: space-between;
`;

const ControlButton = styled(Button)`
    width: 150px;
    text-align: center;
`;

const DayComponent = ({ children = [], eventsForDay = [], badgeLabel = "", onClick = (day, date) => console.log("todo"), day = undefined, maxDisplayed = 4 }) => {
    const [show, setShow] = useState(true);
    const [blockContent, setBlockContent] = useState([]);

    useEffect(() => {
        setBlockContent(_.map(eventsForDay, (event, index) => {
            const childProps = { scope: event };

            return <View key={index}>
                {injectScopeToChildren(children, childProps)}
            </View>;
        }));

        if (eventsForDay.length <= maxDisplayed) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [eventsForDay]);

    let badge = <TouchableOpacity
        onPress={() => setShow(!show)} >
        <Text>{badgeLabel}</Text>
        <Text>{eventsForDay.length}</Text>
        {blockContent.slice(0, maxDisplayed)}
    </TouchableOpacity>;

    return <Day key={day.format('D')} onPress={() => onClick(day.format('D'), day.format('YYYY-MM-DD'))}>
        <View>
            <DayOfMonth><DayOfMonthText>{day.format('D')}</DayOfMonthText></DayOfMonth>
            {show ? null : badge}
            {show ? blockContent : null}
        </View>
        <View>
            {children}
        </View>
    </Day>;
}

const Month = ({children = [], data = [], date = undefined, onClickDay = (day, date) => console.log(day), maxEventsDisplayedPerDay = 4 }) => {
    const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

    const headers = _.map(weekDays, (heading) => {
        return <DayHeading key={heading}>
            <Text>{heading}</Text>
        </DayHeading>;
    });

    const weeks = [];

    const startDate = moment(date, "MMM YYYY");
    startDate.set({ date: 1 });

    let currentWeek = [];
    for (var x = 1; x <= startDate.day(); x++) {
        currentWeek.push(<Day key={-1 * x}></Day>);
    }
    
    for (var x = 1; x <= startDate.daysInMonth(); x++) {

        var timestamp = moment(startDate).date(x).format('YYYY-MM-DD');

        const eventsForDay = _.filter(data, { date: timestamp });

        currentWeek.push(<DayComponent key={x} onClick={onClickDay} day={moment(startDate).date(x)} eventsForDay={eventsForDay} maxDisplayed={maxEventsDisplayedPerDay}>{children}</DayComponent>);

        if (currentWeek.length == 7) {
            weeks.push(<View key={x+1} style={{display: "flex", flexWrap: "wrap", flexDirection: "row"}} key={"week" + weeks.length}>
                {currentWeek}
            </View>);
            currentWeek = [];
        }
    }

    weeks.push(<View key={currentWeek.length} style={{display: "flex", flexWrap: "wrap", flexDirection: "row"}} >
        {currentWeek}
    </View>);

    return <View style={{display: "flex", flexDirection: "column"}}>
        <CalendarHeading>{startDate.format('MMMM YYYY')}</CalendarHeading>
        <View style={{display: "flex", flexWrap: "wrap", flexDirection: "row"}}>
            {headers}
        </View> 
        <View>
            {weeks}
        </View>
    </View>;
}

const Calendar = ({ children = undefined, title = "", data = [], dateVarName = "", badgeLabel = "", className = "", onClickDay = () => console.log("day click event"), maxEventsDisplayedPerDay = 4 }) => {
    const theme = useTheme();
    const [startDate, setStartDate] = useState(moment().set({ date: 1 }).format('MMM YYYY'));

    const generateCalendarEvents = () => {
        let events = [];
        
        try{
            events = _.map(data, (r) => {
                return { event: r, date: r[dateVarName] };
            });
        }catch(e){
            console.log("couldn't grab calendar events");
        }

        return events;
    }

    const prevMonth = () => {
        setStartDate(moment(startDate).subtract(1, 'months').format('MMM YYYY'));
    }


    const nextMonth = () => {
        setStartDate(moment(startDate).add(1, 'months').format('MMM YYYY'));
    }

    return <View>
        <Heading4>{title}</Heading4>
        <Controls>
            <ControlButton onPress={() => prevMonth()} theme={theme}><BasicText colour="white">Previous</BasicText></ControlButton>
            <ControlButton onPress={() => nextMonth()} theme={theme} ><BasicText colour="white">Next</BasicText></ControlButton>
        </Controls>
        <Month onClickDay={onClickDay} data={generateCalendarEvents()} date={startDate} maxEventsDisplayedPerDay={maxEventsDisplayedPerDay}>
            {children}
        </Month>
    </View>
}

export { Calendar };